import { ReactNode } from 'react';
import AppHeader from '@/components/Elements/Header/AppHeader';

interface Props {
  children: ReactNode;
  title?: string;
  backButton?: boolean;
  handleBack?: () => void;
  noTitle?: boolean;
  noLogo?: boolean;
  noMyPage?: boolean;
}

function Layout({
  children,
  title,
  backButton = false,
  handleBack,
  noTitle = false,
  noLogo = false,
  noMyPage = false
}: Props) {
  return (
    <>
      <AppHeader
        title={title}
        showBackButton={backButton}
        handleBack={handleBack}
        noTitle={noTitle}
        noLogo={noLogo}
        noMyPage={noMyPage}
      />
      {children}
    </>
  );
}

export default Layout;
